module.exports = __webpack_public_path__ + "imgs/greenbits.e459221d1f9ad22cbde8de97d2fc33a1.jpg";